const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';

export const SERVICE_DISTRIBUTION_OPTIONS = IS_PRODUCTION
  ? [
      { value: 'odk', label: 'odk' },
      { value: 'amasian', label: 'amasian' },
      { value: 'odc', label: 'odc' },
    ]
  : [
      { value: 'odk-staging', label: 'odk-staging' },
      { value: 'amasian-staging', label: 'amasian-staging' },
      { value: 'odc-staging', label: 'odc-staging' },
    ];

export const STATUS_OPTIONS = [
  { value: 'published', label: 'enabled' },
  { value: 'unpublished', label: 'disabled' },
  // { value: 'draft', label: 'Draft' },
];

// 영화는 TV 등급이 아니라 MPAA 영화 등급을 쓴다.
export const MOVIE_AGE_RATING = ['G', 'PG', 'PG-13', 'R', 'NC-17'];

// ucms-be 의 convert_mpaa_to_odkr(영화 분기)와 같은 대응이어야 한다.
export const MOVIE_AGE_RATING_ODKR_MAP: Record<string, string> = {
  G: 'All',
  PG: 'R12',
  'PG-13': 'R13',
  R: 'R17',
  'NC-17': 'R17',
};

export const MOVIE_AGE_RATING_OPTIONS = MOVIE_AGE_RATING.map(rating => ({
  value: rating,
  label: MOVIE_AGE_RATING_ODKR_MAP[rating]
    ? `${rating} (${MOVIE_AGE_RATING_ODKR_MAP[rating]})`
    : rating,
}));
